import Compatibility from '@helpers/Compatibility';

//高度参数
export const height = {
  column: 200,
  unit: 50,
  half: 25
};

//缓动参数
export const ease = {
  quadratic: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
  circular: 'cubic-bezier(0.1, 0.57, 0.1, 1)'
};

export function getMomentumY(
  currentY,
  startY,
  diffTime,
  maxNegativeY,
  deceleration = 0.0006
) {
  let distance = currentY - startY;
  const speed = Math.abs(distance) / diffTime;

  let dest = currentY + (speed * speed) / (2 * deceleration) * (distance < 0 ? -1 : 1);
  let duration = speed / deceleration;

  if(dest < maxNegativeY) {
    dest = maxNegativeY - (height.column / 2.5 * (speed / 8));
    distance = Math.abs(dest - currentY);
    duration = distance / speed;
  } else if(dest > 0) {
    dest = height.column / 2.5 * (speed / 8);
    distance = Math.abs(currentY) + dest;
    duration = distance / speed;
  }

  return {
    dest: Math.round(dest),
    duration
  };
}

export function getComputedY(scroller) {
  let matrix = window.getComputedStyle(scroller, null);
  matrix = matrix[Compatibility.css.transform].split(')')[0].split(', ');
  return Math.round(matrix[13] || matrix[5]);
}
